import React, { useState } from 'react';
import PropTypes from 'prop-types';
import {
  Accordion,
  AccordionItem,
  AccordionItemHeading,
  AccordionItemButton,
  AccordionItemPanel
} from 'react-accessible-accordion';
import Container from '../../layout/container/container';
import Headline from '../../atoms/headline/headline';
import MixedCopy from '../mixed-copy/mixedCopy';
import AngleDown from '../../icons/angleDown.svg';
import StyledBanner from './banner.style';

const Banner = ({ headline, subline, copy }) => {
  const [isOpen, setOpen] = useState(false);

  return (
    <StyledBanner isOpen={isOpen}>
      <Container>
        <Accordion allowZeroExpanded onChange={expandedIds => setOpen(expandedIds.length > 0)}>
          <AccordionItem className="banner__item">
            <AccordionItemHeading className="banner__title">
              <AccordionItemButton>
                <Headline>{headline}</Headline>
                <AngleDown />
              </AccordionItemButton>
            </AccordionItemHeading>
            <AccordionItemPanel className="banner__content">
              {subline && <Headline subline>{subline}</Headline>}
              <MixedCopy className="banner__copy" html={copy} fullWidth />
            </AccordionItemPanel>
          </AccordionItem>
        </Accordion>
      </Container>
    </StyledBanner>
  );
};

Banner.propTypes = {
  headline: PropTypes.string.isRequired,
  subline: PropTypes.string,
  copy: PropTypes.string.isRequired
};

export default Banner;
